import React, { useMemo } from 'react';
import type { CategoryTreeItem } from './sub-category-map';
import { getSubCategoryMap } from './sub-category-map';
import CategoryListItem from './components/category-item';
import { atLeastOne } from './utils';
import CategoryItemAd from './components/category-item-ad';
import { StyledCategoryList } from './styles';
import type { ICategoryListProps } from './types';

const ads = {
  mobileInlineAd1: <CategoryItemAd />,
};

const CategoryList: React.FC<
  React.PropsWithChildren<React.PropsWithChildren<ICategoryListProps>>
> = props => {
  const {
    limitSubCategories = 5,
    withAds = false,
    displayLinkedCategories = true,
  } = props;

  const fewThreshold = 4;
  const categories = props.categories as CategoryTreeItem[];

  const subCategoryMap = useMemo(
    () =>
      getSubCategoryMap(
        categories,
        limitSubCategories,
        displayLinkedCategories
      ),
    [categories, limitSubCategories, displayLinkedCategories]
  );

  return atLeastOne(categories) ? (
    <StyledCategoryList
      $few={categories.length < fewThreshold}
      data-test="CategoryList"
    >
      {withAds && ads.mobileInlineAd1}

      {categories.map((topLevel, index) => (
        <CategoryListItem
          key={topLevel.id}
          item={topLevel}
          index={index}
          subCategoryMap={subCategoryMap}
        />
      ))}
    </StyledCategoryList>
  ) : null;
};

export { CategoryList };
